/* eslint-disable @typescript-eslint/no-deprecated */
/* eslint-disable sonarjs/deprecation */
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {BrowserModule, bootstrapApplication} from '@angular/platform-browser';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import AppPreset from '@app/app.preset';
import {providePrimeNG} from 'primeng/config';
import {AccountsModule} from './app/accounts/accounts.module';
import {AppRoutingModule} from './app/app-routing.module';
import {AppComponent} from './app/app.component';
import {AuthConfigModule} from './app/auth-config/auth-config.module';
import {AuthOidcInterceptor} from './app/auth-config/interceptors/auth-oidc.Interceptor';
import {CategoryModule} from './app/category/category.module';
import {CheckoutModule} from './app/checkout/checkout.module';
import {CoreModule} from './app/core/core.module';
import {MaintenanceModeModule} from './app/maintenance-mode/maintenance-mode.module';
import {OrderModule} from './app/order/order.module';
import {PageNotFoundModule} from './app/page-not-found/page-not-found.module';
import {ProductModule} from './app/product/product.module';
import {SearchModule} from './app/shared/modules/search/search.module';
import {SharedModule} from './app/shared/shared.module';
import {SignUpModule} from './app/signUp/sign-up.module';
import {StaticPagesModule} from './app/static-pages/static-pages.module';

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      CoreModule.forRoot(),
      BrowserModule,
      AppRoutingModule,
      SharedModule,
      SignUpModule,
      OrderModule,
      CheckoutModule,
      AuthConfigModule,
      StaticPagesModule,
      MaintenanceModeModule,
      PageNotFoundModule,
      AccountsModule,
      SearchModule,
      CategoryModule,
      ProductModule
    ),
    {provide: HTTP_INTERCEPTORS, useClass: AuthOidcInterceptor, multi: true},
    provideZoneChangeDetection({eventCoalescing: true}),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AppPreset,
        options: {
          darkModeSelector: 'none',
        },
      },
    }),
    provideAnimations(),
  ],
}).catch(err => console.error(err)); // NOSONAR
